import React from 'react';

export const CloseIcon = ({ color = '#181818', ...restProps }) => {
  return (
    <svg
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      stroke={color}
      {...restProps}
    >
      <path d="M15 5L5 15" strokeLinecap="round" strokeLinejoin="round" />
      <path d="M5 5L15 15" strokeLinecap="round" strokeLinejoin="round" />
    </svg>
  );
};
